<script>
import axios from 'axios';
import Paginator from '@/components/datatables/Paginator.vue';
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import { downloadFile } from '@/utils/fileDownloader';
import { watch } from 'vue';
import { useRoute } from 'vue-router';

export default {
  components: {
    Paginator
  },
  props: {
    filterDate: {
      type: String,
      default: ''
    },
    TableType: {
      types: String,    
    }
  },
  data() {
    return {
      result: { 
        data: [], 
        from: 0, 
        to: 0, 
        total: 0 
      },
      loadingList: false,
      detailSubmission: {},
      CompletedCountCountNo: 0,
      FailedCountNo: 0,
      waitingCountNo: 0,
      totalSubmission: 0,
    };
  },
  methods: {
    getlist(page = 1) {
      this.loadingList = false;

      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');

      axios.get(process.env.VUE_APP_AR_API_BASEURL + this.TableType + '/dashboard/'+this.filterDate, {
        params: {
          page: page,
        }
      })
      .then(response => {
        if (response) {
            console.log('API Response:', response.data); // Debug log
            this.result = response.data; // Store the response data
            this.loadingList = true;
            
            // ✅ Emit search-complete with correct hasData flag
            const hasData = Array.isArray(response.data?.data) && response.data.data.length > 0;
            this.$emit('search-complete', hasData);
        } else {
            console.warn('No data received from API');
            this.result = { data: [] };
            this.loadingList = true;
            this.$emit('search-complete', false);
        }
      })
      .catch(error => {
        console.error('API Error:', error);
        this.result = { data: [] };
        this.loadingList = true;
        this.$emit('search-complete', false);
      })
      .finally(() => {
        // Keep loadingList as true since we want to show the table
      });
    },
    exportSubmission(jobid) {
      downloadFile(
          process.env.VUE_APP_AR_API_BASEURL + this.TableType +'/export/submission' + jobid,
          'recollect job Id '+ jobid + '.xlsx'
      );
    },

  },
  setup() {
    const route = useRoute();
    const getlist = () => { /* fetch data logic */ };

    watch(() => route.params.date, (newDate, oldDate) => {
      if (newDate !== oldDate) getlist();
    });

  },
    mounted() {
        this.getlist();
    }
};
</script>


<template>
    <div>
        <div class="table-responsive mt-3">
            <div v-if="loadingList == false">
                <div class="spinner-border text-success" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div v-else>
                <table class="table table-striped table-nowrap mb-0">
                    <thead class="table-secondary">
                        <tr>
                            <th>Customer Name</th>
                            <th>Ref. No</th>
                            <th>Reference Number</th>
                            <th>Amount</th>
                            <th>Batch ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!result.data || result.data.length === 0">
                            <td colspan="5" class="text-center text-muted py-4">
                                <i class="ri-inbox-line fs-24 d-block mb-2"></i>
                                No data available
                            </td>
                        </tr>
                        <tr v-else v-for="(item, index) in result.data" :key="index" class="content">
                            <td>{{ item.customer?.name_as_per_nric ?? 'N/A' }}</td>
                            <td>{{ item.invoice?.invoice_no ?? 'N/A' }}</td>
                            <td>{{ item.mandate_ref ?? 'N/A' }}</td>
                            <td>RM {{ item.amount ?? 'N/A' }}</td>
                            <td>{{ item.submission.batch_id ?? 'N/A' }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="mt-4" style="display: flex; justify-content: space-between; align-items: center;">
                    <div>Showing {{ result.from }} to {{ result.to }} of {{ result.total }} results</div>
                    <Paginator :data="result" :limit="1" @pagination-change-page="getlist"></Paginator>
                </div>
            </div>
        </div>
    </div>
</template>